import * as React from 'react';

import { V2rayModuleViewProps } from './V2rayModule.types';

function V2rayModuleWebView(props: V2rayModuleViewProps) {
  return (
    <div>
      <span>{props.name}</span>
    </div>
  );
}

export default V2rayModuleWebView;
